// Libs
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { Box, Button, Popover } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
// Components, Layouts, Pages
import { BaseInput } from '~/components/common';
// Others
import { defaultValuesRepairedQuantity, schema } from './helper';
import { IBodyRepairedQuarantine } from '~/utils/interface/quarantine';
// Styles, images, icons
import styles from './RepairedModal.module.scss';

type Props = {
  open: boolean;
  anchorEl: HTMLElement | null;
  onApply: (quantity: number) => void;
  onClose: () => void;
};

const cx = classNames.bind(styles);

const RepairedModal = (props: Props) => {
  //#region Destructuring Props
  const { anchorEl, open, onClose, onApply } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/base, common/quarantine']);

  const {
    control,
    watch,
    setValue,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm<IBodyRepairedQuarantine>({
    resolver: yupResolver(schema(t)),
    defaultValues: defaultValuesRepairedQuantity,
  });
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function

  const handleApply = (body: IBodyRepairedQuarantine) => {
    const { repairedQuantity } = body;

    onApply(+repairedQuantity);
    handleClear();
  };

  const handleClear = () => {
    onClose();
    reset();
  };
  //#endregion Handle Function

  return (
    <Popover
      id='repairedModal'
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      elevation={0}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      slotProps={{
        paper: {
          className: cx('listMenu'),
        },
      }}
    >
      <Box component={'form'} onSubmit={handleSubmit(handleApply)}>
        <Box className={cx('menuContent')}>
          <Controller
            name={'repairedQuantity'}
            control={control}
            render={({ field: { onChange, value } }) => (
              <BaseInput
                height={36}
                label={t('quarantine_title_modal_quantity', { ns: 'common/base' })}
                placeholder={t('quarantine_placeholder_modal_quantity', { ns: 'common/base' })}
                value={value}
                onChange={onChange}
                errorMessage={errors?.repairedQuantity?.message}
                type={'number'}
                required
              />
            )}
          />
        </Box>
        <Box className={cx('menuFooter')}>
          <Button variant='outlined' className={cx('buttonClear')} onClick={handleClear}>
            {t('common_action_cancel', { ns: 'common/base' })}
          </Button>

          <Button variant='contained' className={cx('buttonApply')} type='submit'>
            {t('common_action_save', { ns: 'common/base' })}
          </Button>
        </Box>
      </Box>
    </Popover>
  );
};

export default RepairedModal;
